<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div
  *ngFor="let message of allMessages; index as idx"
  class="toast-message message-holder lf-flexbox-col"
  [ngClass]="{
    error: message.type === 'Error',
    warning: message.type === 'Warning',
    validation: message.type === 'Validation',
    informational: message.type === 'Informational'
  }"
>
  <div class="lf-flexbox-row lf-flexbox-center both-axis">
    <span
      class="material-icons-outlined"
      style="flex: 0 0 auto"
      [ngClass]="{
        warningIcon: message.type === 'Warning',
        'hide-icon': message.noIcon
      }"
      [attr.aria-label]="message.type"
    >
      {{ _computeTypeIcon(message.type) }}
    </span>
    <div
      class="message-text lf-flex-item lf-flexbox-row"
      [ngClass]="{
        error: message.type === 'Error',
        warning: message.type === 'Warning',
        validation: message.type === 'Validation',
        informational: message.type === 'Informational',
        'no-left-padding': message.noIcon
      }"
    >
      <div class="message-wrapper">
        {{ message.message }}
      </div>
    </div>
    <button
      id="close-btn"
      (click)="_closeToast(message.id)"
      style="flex: 0 0 auto"
      [ngClass]="{
        warningIcon: message.type === 'Warning'
      }"
    >
      <span class="material-icons-outlined" aria-label="close"> close </span>
    </button>
  </div>
</div>
